<!-- A completely blank template results in strange behaviour. This empty DIV fixes it.--><div></div>